if (!customElements.get("autopopup-modal")) {
  customElements.define(
    "autopopup-modal",
    class AutopopupModal extends ModalDialog {
      constructor() {
        super();

        this.delay = parseInt(this.getAttribute("data-delay"));
        this.frequency = parseInt(this.getAttribute("data-frequency"));

        this.teaser = null;
        this.teaserClose = null;
        this.initialized = false;
        this.boundHandleTeaserClose = this.handleTeaserClose.bind(this);

        // 常驻按钮是兄弟节点，等本轮解析结束后再初始化，
        // 避免编辑器内联重渲染 section 时构造器还看不到它
        queueMicrotask(() => this.init());
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        // 弹窗关闭后常驻的订阅按钮
        this.teaser = this.parentElement?.querySelector(
          "[data-autopopup-teaser]",
        );
        this.teaserClose = this.teaser?.querySelector(
          "[data-autopopup-teaser-close]",
        );
        this.teaserClose?.addEventListener("click", this.boundHandleTeaserClose);

        const lastShowTimeStr = webvista.getCookie(
          "popup_newsletter_frequency",
        );
        const lastShowTime = lastShowTimeStr
          ? parseInt(lastShowTimeStr, 10)
          : null;

        // 将频率转换为秒（1天 = 86400秒）
        const frequencyInSeconds = this.frequency * 86400;
        // 获取当前时间的时间戳，单位也是秒
        const currentTime = Math.floor(Date.now() / 1000);

        // 检查当前时间与上次显示时间的差是否大于等于设置的频率
        const shouldAutoShow =
          !window.Shopify.designMode &&
          (lastShowTime == null ||
            currentTime - lastShowTime >= frequencyInSeconds);

        // 订阅成功后不再显示常驻按钮
        const hasSubscribed = this.querySelector(
          ".alert-message.alert-success",
        );

        if (shouldAutoShow) {
          webvista.setCookie(
            "popup_newsletter_frequency",
            currentTime.toString(),
          );
          setTimeout(() => {
            this.show();
          }, this.delay * 1000);
        } else if (
          window.Shopify.designMode ||
          (!hasSubscribed &&
            !this.isTeaserDismissed(currentTime, frequencyInSeconds))
        ) {
          // 不自动弹出时（含编辑模式）常驻显示订阅入口
          this.showTeaser();
        }
      }

      disconnectedCallback() {
        this.teaserClose?.removeEventListener(
          "click",
          this.boundHandleTeaserClose,
        );
      }

      show(opener) {
        super.show(opener);
        this.hideTeaser();
      }

      hide() {
        super.hide();

        // 订阅成功后不再显示常驻按钮
        if (!this.querySelector(".alert-message.alert-success")) {
          this.showTeaser();
        }
      }

      /**
       * 显示常驻订阅按钮
       */
      showTeaser() {
        this.teaser?.removeAttribute("hidden");
      }

      /**
       * 隐藏常驻订阅按钮
       */
      hideTeaser() {
        this.teaser?.setAttribute("hidden", "");
      }

      /**
       * 常驻订阅按钮是否已被关闭
       */
      isTeaserDismissed(currentTime, frequencyInSeconds) {
        const dismissedTimeStr = webvista.getCookie("popup_newsletter_teaser");
        if (dismissedTimeStr == null) return false;

        return (
          currentTime - parseInt(dismissedTimeStr, 10) < frequencyInSeconds
        );
      }

      /**
       * 关闭常驻订阅按钮
       */
      handleTeaserClose(event) {
        event.preventDefault();
        event.stopPropagation();

        webvista.setCookie(
          "popup_newsletter_teaser",
          Math.floor(Date.now() / 1000).toString(),
        );
        this.hideTeaser();
      }
    },
  );
}

if (!customElements.get("autopopup-age-verifier")) {
  customElements.define(
    "autopopup-age-verifier",
    class AutopopupAgeVerifier extends ModalDialog {
      constructor() {
        super();

        this.boundHandleDecline = this.handleDecline.bind(this);
        this.boundHandleSatisfy = this.handleSatisfy.bind(this);
        this.boundHandleReturn = this.handleReturn.bind(this);

        const debugModel = this.hasAttribute("data-debug-model"); // 调试模式，强制每次刷新页面都要弹出年龄验证
        const lastVerified = webvista.getCookie("autopopup_age_verifier");
        const currentTime = Math.floor(Date.now() / 1000);

        if (
          debugModel ||
          (!window.Shopify.designMode &&
            (lastVerified == null || currentTime - lastVerified > 7 * 86400))
        ) {
          this.show();
        }
      }

      show() {
        super.show();

        this.querySelector("button[data-declined]")?.addEventListener(
          "click",
          this.boundHandleDecline,
        );
        this.querySelector("button[data-satisfied]")?.addEventListener(
          "click",
          this.boundHandleSatisfy,
        );
      }

      hide() {
        super.hide();

        this.querySelector("button[data-declined]")?.removeEventListener(
          "click",
          this.boundHandleDecline,
        );
        this.querySelector("button[data-satisfied]")?.removeEventListener(
          "click",
          this.boundHandleSatisfy,
        );
        this.querySelector("button[data-return]")?.removeEventListener(
          "click",
          this.boundHandleReturn,
        );
      }

      /**
       * 处理不满足条件
       */
      handleDecline() {
        this.classList.add("age-verifier--has-decline");
        this.querySelector("button[data-return]")?.addEventListener(
          "click",
          this.boundHandleReturn,
        );
      }

      /**
       * 处理满足条件
       */
      handleSatisfy() {
        const currentTime = Math.floor(Date.now() / 1000);
        webvista.setCookie("autopopup_age_verifier", currentTime);
        this.hide();
      }

      /**
       * 处理返回问题选择页面
       */
      handleReturn() {
        this.classList.remove("age-verifier--has-decline");
      }
    },
  );
}
